<div *ngFor="let details of shoppingDetails;">
    <div>
        <span class="shopping-product-name">{{details.productName}} : </span>  <span class="shopping-details">Rs. {{details.costPrice}} * {{details.quantity}}</span>
    </div>
</div>
